import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const CommunityPage = () => {
  return <SanityContentPage slug='community' />
}

export default CommunityPage
